import styled from 'styled-components'
import { color } from 'sidecar-theme'

export const SubLabel = styled.div`
  font-size: 1.4rem;
  line-height: 2rem;
  position: absolute;
  left: 0;
  color: ${color.GREY};

  // keep "top" tight because it's the InputCell that's
  // making room for this and if it's too far down, it'll
  // run into the label of any field under it. If you adjust
  // this, make sure to adjust the bottom spacing in InputCell.
  top: 6.5rem;
`

export const ErrorMessage = styled(SubLabel)`
  color: ${p => p.theme.color.WATERMELON};
  top: auto;
`

export const RequirementList = styled.ul`
  font-size: 1.4rem;
  margin: 0.5rem 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
`

export const Requirement = styled.li`
  list-style: none;
  flex-basis: 50%;
  color: ${p => p.theme.color};
  transition: color 0.2s;
  margin-top: 1rem;
  padding-left: 3rem;
  position: relative;
  line-height: normal;

  &:before {
    content: '';
    position: absolute;
    top: -0.2rem;
    left: 0.5rem;
    height: 1.5rem;
    width: 1.5rem;
    border-radius: 100%;
    background: ${p => p.theme.bulletColor};
    transition: background-color 0.2s;
  }
`


// WEBPACK FOOTER //
// ./src/sidecar-utils/lib/enhancers/toReduxFormField/styles.js